import React, { useState, useEffect, useRef } from 'react';
import {
    Card,
    CardContent,
    Stack,
    Box
} from '@mui/material';
import CustomDateRangePicker from '../../Dashboard/components/CustomDateRangePicker';
import { useContent } from '../../../../context/ContentContext';
import format from 'date-fns/format';
import subYears from 'date-fns/subYears';
import DebitCard from './DebitCard';
import BalanceIncomeCard from './BalanceIncomeCard';
import TransaksiHistory from './TransaksiHistory';

const TransaksiDisplay = () => {
    const [dateRange, setDateRange] = useState({ startDate: null, endDate: null });
    const { fetchSaldoData, saldoData, fetchHistoryData, HistoryData } = useContent();
    const [type, setType] = useState("semua"); // Default to "semua"

    const isFirstRender = useRef(true);

    const handleDateChange = ({ startDate, endDate }) => {
        if (!startDate || !endDate) {
            console.error("Start date and end date are required.");
            return;
        }

        try {
            const formattedStartDate = format(new Date(startDate), 'yyyy-MM-dd');
            const formattedEndDate = format(new Date(endDate), 'yyyy-MM-dd');

            if (isNaN(new Date(formattedStartDate).getTime()) || isNaN(new Date(formattedEndDate).getTime())) {
                console.error("Invalid date format.");
                return;
            }

            setDateRange({ startDate: formattedStartDate, endDate: formattedEndDate });
            fetchSaldoData(formattedStartDate, formattedEndDate);
            fetchHistoryData(formattedStartDate, formattedEndDate, type);
        } catch (error) {
            console.error("Error formatting dates:", error);
        }
    };

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            const defaultStartDate = subYears(new Date(), 4);
            const defaultEndDate = new Date();

            handleDateChange({
                startDate: format(defaultStartDate, 'yyyy-MM-dd'),
                endDate: format(defaultEndDate, 'yyyy-MM-dd'),
            });
        }
    }, []);

    return (
        <Stack spacing={2} direction="column" justifyContent="center" alignItems="center">
            <Card sx={{ padding: 0, border: 0 }}>
                <CardContent>
                    <DebitCard />
                </CardContent>
            </Card>

            <CustomDateRangePicker onDateChange={handleDateChange} />
            <Box
                sx={{
                    width: '100%',
                    overflowX: 'auto', // Enables horizontal scrolling
                    display: 'flex',
                    justifyContent: 'start',
                }}
            >
                <BalanceIncomeCard saldoData={saldoData} />
            </Box>
            <Box
                sx={{
                    width: '100%',
                    maxWidth: {
                        xs: '100vw',  // On mobile, use max-width 100vw
                        sm: '100%',   // On tablet and larger, use full width
                        md: '100%',   // On desktop, use full width
                        lg: '70vw',  // You can also customize for larger screens
                    },
                    maxHeight: '400px', // Adjust based on the available height
                    overflowY: 'auto', // Enables vertical scrolling
                    position: 'sticky',
                    top: 0,  // Stick to the top of the screen
                    zIndex: 1, // Ensures it stays above other content when scrolling
                    backgroundColor: 'white', // To maintain the background color when scrolling
                }}
            >
                <TransaksiHistory
                    type={type}
                    setType={setType}
                    startDate={dateRange.startDate}
                    endDate={dateRange.endDate}
                />
            </Box>

        </Stack>
    );
};

export default TransaksiDisplay;